import urls from "api/urls";
import axios from "config/axios";
import localStorage from "helpers/localStorage";
import { toast } from "react-hot-toast";

const login = async (loginInfo) => {
  try {
    const response = await axios.post(urls.login, loginInfo);
    const { access, refresh } = response.data;
    const { token: authToken, expires } = access;
    localStorage.setItem("authToken", authToken);
    localStorage.setItem("isAuthenticated", true);
    localStorage.setItem("expiryDate", expires);

    toast.success("Successfully login.");
    return response.data;
  } catch (err) {
    const errorObj = err?.response?.data
    const firstErrorMsg = Object.values(errorObj)[0]
    toast.error("You may provide bad credentials:"+firstErrorMsg)
  }
};

const signUp = async (signUpInfo) => {
  try {
    const response = await axios.post(urls.signUp, signUpInfo);
    const { access, refresh } = response.data;
    const { token: authToken, expires } = access;
    localStorage.setItem("authToken", authToken);
    localStorage.setItem("isAuthenticated", true);
    localStorage.setItem("expiryDate", expires);
    toast.success("Successfully login.");
    return response.data;
  } catch (err) {
    const errorObj = err?.response?.data
    const firstErrorMsg = Object.values(errorObj)[0]
    toast.errork("Something went wrong:"+firstErrorMsg)
  }
};

const refreshTokens = () => {
  // TODO
  // implement refresh tokens logic
};

const logout = async () => {
  toast.success("Logout successfully.");
  localStorage.clear();
};

export { login, signUp, logout, refreshTokens };
